/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Prevent Klaviyo newsletter popups from closing when users interact with the
 * cookie consent banner.
 *
 * Klaviyo treats any click outside its form as a dismissal. Clicks on Shopify's
 * native cookie banner bubble up to the document, so Klaviyo interprets them as
 * outside clicks and closes the popup. We stop that propagation at the banner.
 */
(() => {
  // Shopify Customer Privacy API banner + theme fallback cookie bar
  const COOKIE_BANNER_SELECTOR = [
    '#shopify-pc__banner',
    '#shopify-pc__prefs',
    '.shopify-pc__prefs__overlay',
    '.cookie-bar'
  ].join(', ');

  // Events Klaviyo may use to detect outside interaction
  const INTERACTION_EVENTS = ['click', 'mousedown', 'mouseup', 'touchstart', 'touchend', 'pointerdown'];

  // Stop the event from reaching document-level listeners (e.g. Klaviyo)
  const stopEventBubbling = (event) => {
    event.stopPropagation();
  };

  // Attach bubble guards to a single banner element (idempotent via data attribute)
  const protectCookieBanner = (element) => {
    if (!element || element.dataset.klaviyoBubbleGuard === 'true') {
      return;
    }

    element.dataset.klaviyoBubbleGuard = 'true';

    INTERACTION_EVENTS.forEach((eventName) => {
      element.addEventListener(eventName, stopEventBubbling);
    });
  };

  // Find all cookie banner elements currently in the DOM
  const scanForCookieBanners = () => {
    document.querySelectorAll(COOKIE_BANNER_SELECTOR).forEach(protectCookieBanner);
  };

  // Run on load and watch for dynamically injected banners (storefront-banner.js)
  const initCookieBannerBubbleGuard = () => {
    scanForCookieBanners();

    new MutationObserver(scanForCookieBanners).observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  if (document.body) {
    initCookieBannerBubbleGuard();
  } else {
    document.addEventListener('DOMContentLoaded', initCookieBannerBubbleGuard);
  }
})();
